<div class="create-pwd-container">
  <div class="text-center d-flex justify-content-center align-items-center" style="margin-bottom: 45px;">
    <img src="../../assets/webtree.png" alt="">
    <span class="mx-2"> | </span>
    <p class="f-24 font-weight-600 mb-0" style="color: #484b59;">Talent Discovery</p>
  </div>
  <div class="set-pwd-container" *ngIf="showCreatePasswordPage">
    <div>
      <p>Hi {{userDetails.name}}</p>

      <div>
        <div class="f-18 font-weight-600 my-1">Set Password</div>

        <div class="text-9696 f-14">
          Fill in the details to Set Password
        </div>
      </div>
      <div class="font-weight-500 f-14 mt-4">
        <!-- Email form control -->
        <div class="mb-4">
          <div class="f-14 mb-1">Work Email ID </div>
          <input data-testid="auto-app-create-password-input-1" [formControl]="emailForm" class="wc-form-control nobg"
            style="background-color: #f2f2f2; color: #969696;" />
        </div>

        <!-- password -->
        <div class="mb-4">
          <div class="mb-1" class="d-flex justify-content-between">
            <span class="mb-1">Enter password</span>
            <span *ngIf="checkConstraints('valid-password')" class="errMsg">Invalid password</span>
          </div>
          <input data-testid="auto-app-create-password-input-2" [type]="showPassword ? 'text' : 'password'" class="wc-form-control" [formControl]="passwordForm"
            placeholder="Enter password" />
          <span class="show-password"><i class="fas text-webbtree-green"
              [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'" (click)="showPassword=!showPassword"></i></span>

          <div class="f-12 text-9696 d-flex justify-content-between">
            <div class="d-flex flex-column">
              <span class="mb-1">
                <i class="fa-solid fa-circle-check mr-1"
                  [ngStyle]="!checkConstraints('length') && {'color': '#9ae558'}"></i>
                8-48 characters
              </span>
              <span class="mb-1">
                <i class="fa-solid fa-circle-check mr-1"
                  [ngStyle]="!checkConstraints('hasCapitalCase') && {'color': '#9ae558'}"></i>
                Include 1 uppercase letter
              </span>
              <span class="mb-1">
                <i class="fa-solid fa-circle-check mr-1"
                  [ngStyle]="!checkConstraints('hasSmallCase') && {'color': '#9ae558'}"></i>
                Include 1 lowercase letter
              </span>
            </div>

            <div class="d-flex flex-column">
              <span class="mb-1">
                <i class="fa-solid fa-circle-check mr-1"
                  [ngStyle]="!checkConstraints('hasSpecialCharacters') && {'color': '#9ae558'}"></i>
                Include 1 special character
              </span>
              <span class="mb-1">
                <i class="fa-solid fa-circle-check mr-1"
                  [ngStyle]="!checkConstraints('hasNumber') && {'color': '#9ae558'}"></i>
                Include 1 number (0-9)
              </span>
              <span class="mb-1">
                <i class="fa-solid fa-circle-check mr-1"
                  [ngStyle]="!checkConstraints('hasKeyword') && {'color': '#9ae558'}"></i>
                Must not contain "password"
              </span>
            </div>
          </div>
        </div>

        <!-- retype password -->
        <div class="mb-4">
          <div class="mb-1 d-flex justify-content-between">
            <span>
              Enter Confirm Password*
            </span>
            <span *ngIf="checkConstraints('valid-confirm-password')" class="errMsg">Invalid password</span>
          </div>
          <input data-testid="auto-app-create-password-input-3" [type]="showConfirmPassword ? 'text' : 'password'" [formControl]="confirmPassword"
            class="wc-form-control nobg" placeholder="Enter password" />
          <span class="show-password"><i class="fas text-webbtree-green"
              [ngClass]="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'"
              (click)="showConfirmPassword=!showConfirmPassword"></i></span>
        </div>
      </div>

      <button data-testid="auto-app-create-password-button-1" class="btn-trms-medium w-100" (click)="submitPassword()">
        <span *ngIf="!isLoadingSetpassword">Save</span>
        <span *ngIf="isLoadingSetpassword">
          <img style="width: 20px;" src="../../assets/rolling-loader-white.gif" alt="">
        </span>
      </button>
    </div>
  </div>

  <div class="set-pwd-container text-center" *ngIf="somethingWentWrong">
    <div style="margin-bottom: 32px;" class="text-center">
      <img src="../../assets/something-went-wrong.png" alt="Unsubscribe">
    </div>
    <div class="text-484b59 f-20 font-weight-500">Someting went wrong</div>
  </div>

  <div class="set-pwd-container text-center" *ngIf="passwordAlreadyCreated">
    <div style="margin-bottom: 32px;" class="text-center">
      <img src="../../assets/something-went-wrong.png" alt="Unsubscribe">
    </div>
    <div class="text-484b59 f-20 font-weight-500">Password already created</div>
  </div>
</div>